<template>
<div>
    <div class="text-left edit-title">
        <p>Edit your profile</p>
    </div>
    <div class="d-flex flex-row justify-content-around " id="editcontent">
        <div >
            <form class="text-left d-flex flex-column justify-content-between editform">
                    <div class="group">
                        <input class="input" v-model="user.FirstName" @input="firstnamechange" :class="{used: firstnameUsed}"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">First Name</label>
                    </div>
                    <div class="group">
                        <input class="input" v-model="user.LastName" @input="lastnamechange" :class="{used: lastnameUsed}"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Last Name</label>
                    </div>
                    <div class="group">
                        <input class="input" v-model="user.Email" @input="emailchange" :class="{used: emailUsed}" readonly/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Email</label>
                    </div>
                    <div class="group">
                        <input class="input" v-model="user.City" @input="citychange" :class="{used: cityUsed}"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">City</label>
                    </div>
                    <div class="group">
                        <input class="input" v-model="user.State" @input="statechange" :class="{used: stateUsed}"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">State</label>
                    </div>
                    <div class="group">
                        <input class="input" v-model="user.Role" @input="rolechange" :class="{used: roleUsed}"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Role</label>
                    </div>
                    <!-- <div class="select">
                        <select v-model="user.Role" class="select-text" @change="rolechange" :class="{used: roleUsed}"> 
                            <option disabled selected value=""></option>
                            <option v-for="(value, index) in roles" v-bind:value="value" :key="index">{{ value }}</option>
                        </select>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Role</label>
                    </div> -->
                    <div class="group">
                        <input class="input" v-model="user.SpiritAnimal" @input="spiritanimalchange" :class="{used: spiritanimalUsed}"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Spirit Animal</label>
                    </div>
                    <div id="fileinput">
                        <label id="filelabel" ref="LabelLogoref">Profile icon</label>
                        <img ref="Iconref" class="loaded-image" hidden="true"/>
                        <label class="fileContainer">
                            Choose
                            <input type="file" @change="iconload" accept="image/*" ref="Icon"/>
                        </label>
                    </div>
                <div class="group">
                        <input class="input" v-model="user.CompanyName" @input="companyNamechange" :class="{used: companyNameused}"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Company Name</label>
                    </div>
                    <div class="group">
                        <input class="input " v-model="user.BriefDescription" @input="briefdescriptionchange" :class="{used: briefdescriptionused}" maxlength="64"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Brief Description</label>
                        <p class="limit" ref="Limit">64</p>
                    </div>
                    <div class="group">
                        <textarea v-model="user.Description" @input="aboutchange" :class="{used: aboutused}" rows="5"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Company Description</label>
                    </div>
                    <div class="group">
                        <label id="filelabel" ref="LabelIconref">Company Logo</label>
                        <img ref="Logoref" class="loaded-image" hidden="true"/>
                        <label class="fileContainer">
                            Choose
                            <input type="file" @change="logoload" accept="image/*" ref="Logo" />
                        </label>
                    </div>
                    <div class="group">
                        <textarea v-model="user.Message" @input="messagechange" :class="{used: messageused}" rows="7"/>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label">Your Message</label>
                    </div>
            </form>
        </div>
    </div>
        <div id="bottom-buttons">
            <p v-if="feedback" class="feedback">{{feedback}}</p>
            <a href="#" @click.prevent="cancel" id="cancel" class="bottom-button">Cancel</a>
            <a href="#" @click.prevent="apply" id="apply" class="bottom-button">Apply Changes</a>
        </div>
    </div>
</template>
<script>
import firebase from '@/firebase/init'
import Compressor from 'image-compressor.js'
export default {
    name: 'EditProfile',
    data(){
        return{
            roles:['Founder', 'CEO'],
            user: {
                FirstName: null,
                LastName: null,
                Email: null,
                City: null,
                State: null,
                Role: null,
                SpiritAnimal: null,
                Icon: null,
                CompanyName: null,
                BriefDescription: null,
                Description: null,
                Logo: null,
                Message: null
            },
            displayName: null,
            firstnameUsed: false,
            lastnameUsed: false,
            emailUsed: false,
            cityUsed: false,
            stateUsed: false,
            roleUsed: false,
            spiritanimalUsed: false,
            companyNameused: false,
            briefdescriptionused: false,
            aboutused: false,
            messageused: false,
            feedback: null,
            logosrc: null,
            iconsrc: null
        }
    },
    methods:{
        apply(){
            var db = firebase.firestore()
            var storageRef = firebase.storage().ref()
            var thisObj = this
            var token = this.generate_token(32)
            if(this.user.FirstName && this.user.LastName && this.user.Email && this.user.Role && this.user.CompanyName &&
            this.user.BriefDescription && this.user.Description && this.user.Icon && this.user.Logo){
                if(this.displayName != this.user.Name){
                    var user = firebase.auth().currentUser;
                        user.updateProfile({
                        displayName: this.user.FirstName
                        }).catch(function(error) {
                            console.log(error)
                        })
                }
                if(typeof this.user.Icon != 'string'){
                    var compressorIcon = new Compressor(this.user.Icon, {
                        quality: .5,
                        success(result){
                            var iconRef = storageRef.child('images/users/icons/' + token + result.name)
                          
                            iconRef.put(result)
                            .catch(err=>{
                                console.log(err);
                            })
                            var previousRef = storageRef.child(thisObj.iconsrc)
                            previousRef.delete()
                        },
                        error(e){ console.log(e)}
                    })
                    let path = 'images/users/icons/' + token + this.user.Icon.name
                    this.user.Icon = path
                }
                if(typeof this.user.Logo != 'string'){
                    var compressorLogo = new Compressor(this.user.Logo, {
                        quality: .5,
                        success(result){
                            var logoRef = storageRef.child('images/users/logos/' + token + result.name)
                            logoRef.put(result)
                            .catch(err=>{
                                console.log(err)
                            })
                            var previousRef = storageRef.child(thisObj.logosrc)
                            previousRef.delete()
                        },
                        error(e){ console.log(e)}
                    })
                    let path = 'images/users/logos/' + token + this.user.Logo.name
                    this.user.Logo = path
                }
                var userRef = db.collection("users").doc(this.user.id)
                userRef.update({
                    FirstName: this.user.FirstName,
                    LastName: this.user.LastName,
                    City: this.user.City,
                    State: this.user.State,
                    Role: this.user.Role,
                    SpiritAnimal: this.user.SpiritAnimal,
                    CompanyName: this.user.CompanyName,
                    BriefDescription: this.user.BriefDescription,
                    Description: this.user.Description,
                    Icon: this.user.Icon,
                    Logo: this.user.Logo,
                    Message: this.user.Message
                })
                .then(function() {
                    thisObj.$router.push({name: 'Home'})
                })
                .catch(function(error) {
                    console.error("Error updating document: ", error)
                })
            }
            else{
                this.feedback = "You must enter all fields"
            }

        },
        firstnamechange(e){
            this.user.FirstName = e.target.value
            if(this.user.FirstName == null || this.user.FirstName == ''){
                this.firstnameUsed = false
            }
            else {this.firstnameUsed = true}
        },
        lastnamechange(e){
            this.user.LastName = e.target.value
            if(this.user.LastName == null || this.user.LastName == ''){
                this.lastnameUsed = false
            }
            else {this.lastnameUsed = true}
        },
        emailchange(){
            if(this.user.Email == null || this.user.Email == ''){
                if(this.previousemail == null)
                    this.emailUsed = false
                }
            else {this.emailUsed = true}
        },
        citychange(e){
            this.user.City = e.target.value
            if(this.user.City == null || this.user.City == ''){
                this.cityUsed = false
            }
            else {this.cityUsed = true}
        },
        statechange(e){
            this.user.State = e.target.value
            if(this.user.State == null || this.user.State == ''){
                this.stateUsed = false
            }
            else {this.stateUsed = true}
        },
        rolechange(e){
            this.user.Role = e.target.value
            if(this.user.Role == null || this.user.Role == ''){
                this.roleUsed = false
            }
            else {this.roleUsed = true}
        },
        spiritanimalchange(e){
            this.user.SpiritAnimal = e.target.value
            if(this.user.SpiritAnimal == null || this.user.SpiritAnimal == ''){
                this.spiritanimalUsed = false
            }
            else {this.spiritanimalUsed = true}
        },
        companyNamechange(e){
            this.user.CompanyName = e.target.value
            if(this.user.CompanyName == null || this.user.CompanyName == ''){this.companyNameused = false}
            else {this.companyNameused = true}
        },
        briefdescriptionchange(e){
            this.user.BriefDescription = e.target.value
            if(this.user.BriefDescription.length <= 64){
                this.$refs.Limit.textContent = 64 - this.user.BriefDescription.length
            }
            if(this.user.BriefDescription == null || this.user.BriefDescription == ''){this.briefdescriptionused = false}
            else {this.briefdescriptionused = true}
        },
        aboutchange(e){
            this.user.Description = e.target.value
            if(this.user.Description == null || this.user.Description == ''){this.aboutused = false}
            else {this.aboutused = true}
        },
        messagechange(e){
            this.user.Message = e.target.value
            if(this.user.Message == null || this.user.Message == ''){this.messageused = false}
            else {this.messageused = true}
        },
        iconload(e){
            var thisobj = this
            this.user.Icon = this.$refs.Icon.files[0]
            var readerIcon  = new FileReader()
            readerIcon.onloadend = function () {
                let res = readerIcon.result
                callbackIcon(res)
            }

            if (this.user.Icon) {
                readerIcon.readAsDataURL(this.user.Icon)
            } else {
                thisobj.$refs.Iconref.src = ""
            }
            function callbackIcon(data){
                thisobj.$refs.LabelIconref.hidden = true;
                thisobj.$refs.Iconref.hidden = false;
                thisobj.$refs.Iconref.src  = data
            }
        },
        logoload(e){
            this.user.Logo = this.$refs.Logo.files[0]
            var readerLogo  = new FileReader()
            var thisobj = this
            readerLogo.onloadend = function () {
                let res = readerLogo.result
                callbackLogo(res)
            }
            if (this.user.Logo) {
                readerLogo.readAsDataURL(this.user.Logo)
            } else {
                thisobj.$refs.Logoref.src = ""
            } 
            function callbackLogo(data){
                thisobj.$refs.LabelLogoref.hidden = true;
                thisobj.$refs.Logoref.hidden = false;
                thisobj.$refs.Logoref.src = data
            }
        },
        cancel(){
            this.$router.push({name: 'Home'})
        },
        generate_token(length){
            //edit the token allowed characters
            var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
            var b = [];  
            for (var i=0; i<length; i++) {
                var j = (Math.random() * (a.length-1)).toFixed(0);
                b[i] = a[j];
            }
            return b.join("");
        }
    },
    created(){
        var db = firebase.firestore()
        var storage = firebase.storage()
        var storageRef = storage.ref()
        var thisObj = this
        firebase.auth().onAuthStateChanged((user)=>{
            if(user){
                this.displayName = user.displayName
                let ref = db.collection('users').where('UID', '==', user.uid)
                ref.get().then(snapshot=>{
                    snapshot.forEach(doc=>{
                        let user = doc.data()
                        let logoRef = storageRef.child(user.Logo)
                        this.logosrc = user.Logo
                        if(logoRef.location.path !== ""){
                            logoRef.getDownloadURL().then(function(url) {
                                thisObj.$refs.LabelLogoref.hidden = true
                                thisObj.$refs.Logoref.hidden = false
                                thisObj.$refs.Logoref.src = url
                            }).catch(function(error) {user.Logo = null})
                        }
                        let avatarRef = storageRef.child(user.Icon)
                        this.iconsrc = user.Icon
                        if(avatarRef.location.path !== ""){
                            avatarRef.getDownloadURL().then(function(url) {
                                thisObj.$refs.LabelIconref.hidden = true
                                thisObj.$refs.Iconref.hidden = false
                                thisObj.$refs.Iconref.src = url
                            }).catch(function(error) {user.Icon = null})
                        }
                        user.id = doc.id
                        this.user = user
                        if(this.user.BriefDescription.length <= 64){
                            this.$refs.Limit.textContent = 64 - this.user.BriefDescription.length
                        }
                    })
                })
                this.firstnameUsed = true
                this.lastnameUsed = true
                this.emailUsed = true
                this.cityUsed = true
                this.stateUsed = true
                this.roleUsed = true
                this.spiritanimalUsed = true
                this.companyNameused = true
                this.briefdescriptionused = true
                this.aboutused = true
                this.messageused = true
                
            }
            else{
                this.$router.push({name: 'Login'})
            }
        })
    },
    beforeCreate: function() {
            document.body.className = 'registration'
            this.$parent.showNavbar = true   
            this.$parent.showBackButton = true     
    }
}
</script>
<style scoped>
/* .editform{
    margin-top: 4em;
} */
.limit{
    position: absolute;
	top: 5px;
	right: 5px;

    padding: 2px 4px 1px 4px;
	
    font-size: 8px;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    border: 1px solid #8954BA;
    border-radius: 1em;
	pointer-events: none;
    margin-bottom: 1em;
}
#editcontent{
    width: 90%;
    margin: auto;
    margin-bottom: 0 !important;
}
.edit-title{
    margin-left: 10em;
}
.edit-title p{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 22px;
    color: #686868;
    margin-bottom: 2em;
}
.button{
    text-decoration: none;
    background-color: white;
    border-color: white;
    padding: 1.5em;
    font-family: GothamBook;
    font-size: 14px;
    color: #8954BA;
}
#fileinput{
  margin-top: 2.5em;
}
.group{ 
  position:relative; 
  margin-bottom:35px; 
}
.input{
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width:310px;
  border:none;
  border-bottom:1px solid #D0D6E6;
}
.input:focus{ outline:none; }

.label{
  color:#686868; 
  font-size:18px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  font-family: GothamBook;
  font-size: 14px;
}

.used ~.label{
  top:-20px;
  font-size:14px;
  transition: 0.2s ease all;
  color:#686868;
}
.used{
    color: #8954BA;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.bar  { position:relative; display:block; width:310px; }
.bar:before, .bar:after   {
  content:'';
  height:2px; 
  width:0;
  bottom:1px; 
  position:absolute;
  background:#8954BA; 
  transition:0.2s ease all; 
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%; 
}

.input:focus ~ .bar:before, .input:focus ~ .bar:after {
  width:50%;
}
.highlight {
  position:absolute;
  height:60%; 
  width:100px; 
  top:25%; 
  left:0;
  pointer-events:none;
  opacity:0.5;
  
}

.input:focus ~ .highlight {
  animation:inputHighlighter 0.3s ease;
}

@keyframes inputHighlighter {
  from  { background:#5264AE; }
  to    { width:0; background:transparent; }
}

.select {
	position: relative;
	width: 310px;
}

.select-text {
	position: relative;
	background-color: transparent;
	width: 310px;
	padding: 10px 10px 10px 5px;
	border-radius: 0;
	border: none;
	border-bottom: 1px solid rgba(0,0,0, 0.12);
}

.select-text:focus {
	outline: none;
	border-bottom: 1px solid rgba(0,0,0, 0);
}

.select .select-text {
	appearance: none;
	-webkit-appearance:none
}

.select:after {
	position: absolute;
	top: 18px;
	right: 10px;
	/* Styling the down arrow */
	width: 0;
	height: 0;
	padding: 0;
	content: '';
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid rgba(0, 0, 0, 0.12);
	pointer-events: none;
}
.select-text:focus ~ .bar:before, .select-text:focus ~ .bar:after {
	width: 50%;
}
#fileinput{
  margin-top: 2.5em;
  margin-bottom: 2.5em;
}
.fileContainer {
    overflow: hidden;
    position: relative;
}

.fileContainer [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
}

.fileContainer {
    background: white;
    border: 1px solid #C1C1C1;
    border-radius: 2px;
    float: right;
    padding: 0.1em 1em 0.1em 1em;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}

.fileContainer [type=file] {
    cursor: pointer;
}
#filelabel{
    color: #686868;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.loaded-image{
    height: 5em;
}
/* .limit:after{
    position: absolute;
	top: 18px;
	right: 5px;

    padding: 2px 4px 1px 4px;
	content: '32';
    font-size: 8px;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    border: 1px solid #8954BA;
    border-radius: 1em;
	pointer-events: none;
} */
textarea{
    white-space: pre-wrap;
    border-radius: 0;
    background-color: white;
    resize: none;
    font-size:18px;
    padding:10px 10px 10px 5px;
    display:block;
    width:310px;
    border:none;
    border-bottom:1px solid #D0D6E6;
}
textarea:focus{ outline:none; }
textarea:focus ~ .bar:before, textarea:focus ~ .bar:after {
  width:50%;
}
textarea:focus ~ .highlight {
  animation:inputHighlighter 0.3s ease;
}
.bottom-button{
    margin-left: 0.7em;
    background-color: #5D38DB;
    border-color: white;
    padding: 0.9em 2.1em 0.7em 2.1em;
    border-radius: 2px;
    font-family: GothamBook;
    font-size: 10px;
    color: white !important;
    cursor: pointer !important;
}
#bottom-buttons{
    margin-top: 2em;
    margin-bottom: 1em;
}
@media (max-width: 690px) {
    .editform{
        margin-top: 3em;
    }
    .edit-title{
        padding-top: 1em;
        margin-left: 2.5em;
    }
    .bottom-button{
        margin-bottom: 3em;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/EditProfile.vue